import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'alabia-jwt-dialog',
  templateUrl: './jwt-dialog.component.html',
  styleUrls: ['./jwt-dialog.component.scss']
})
export class JwtDialogComponent implements OnInit {
  constructor(@Inject(MAT_DIALOG_DATA) public data: string) { }

  ngOnInit() {
  }
}
